const CAR_TYPE_LOAD_ERROR = 'ไม่สามารถโหลดรายการประเภทรถได้ กรุณาลองใหม่อีกครั้ง';

const carTypeLoader = {
  data() {
    return {
      carTypeRetryPromptOpen: false,
    };
  },
  methods: {
    async loadCarTypeDict() {
      try {
        const list = await this.$store.dispatch('getCarTypeDict');
        if (
          this.list &&
          !Array.isArray(this.list) &&
          Object.prototype.hasOwnProperty.call(this.list, 'car_type_dict')
        ) {
          this.$set(this.list, 'car_type_dict', list);
        }
        return list;
      } catch (error) {
        const message = (error && error.message) || CAR_TYPE_LOAD_ERROR;
        this.showCarTypeRetryPrompt(message);
        return [];
      }
    },
    // Cached like getCarTypeDict. A failure only disables the "SKU doesn't match the car type"
    // warning (never a blocker), so it is logged instead of prompting the user.
    async loadCarTypeInsuranceSku() {
      try {
        return await this.$store.dispatch('getCarTypeInsuranceSku');
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    showCarTypeRetryPrompt(message) {
      if (this.carTypeRetryPromptOpen) return;
      this.carTypeRetryPromptOpen = true;

      this.$swal({
        icon: 'error',
        title: 'โหลดประเภทรถไม่สำเร็จ',
        text: message,
        confirmButtonText: 'ลองใหม่',
        confirmButtonColor: '#2ba9fc',
        showCancelButton: true,
        cancelButtonText: 'ใช้งานส่วนอื่นก่อน',
        cancelButtonColor: '#999999',
      }).then((result) => {
        this.carTypeRetryPromptOpen = false;
        if (result.isConfirmed && !this._isDestroyed) {
          return this.loadCarTypeDict();
        }
        return null;
      }).catch(() => {
        this.carTypeRetryPromptOpen = false;
      });
    },
  },
};

module.exports = carTypeLoader;
module.exports.CAR_TYPE_LOAD_ERROR = CAR_TYPE_LOAD_ERROR;
